/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { CannonBox } from "../physics/CannonBox";

const model = "/models/room_empty.glb";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF(model);

  return (
    <group ref={group} {...props} dispose={null} position={[1, 0, -1]}>
      <mesh
        receiveShadow
        geometry={nodes.Plane.geometry}
        material={materials.wall}
      />
      <mesh
        receiveShadow
        geometry={nodes.Plane_1.geometry}
        material={materials["wood floor"]}
      />

      {/* Walls Physics */}
      <CannonBox size={[6, 6, 6]} position={[0, -0.08, 0]} />
    </group>
  );
}

useGLTF.preload(model);
